import { defineComponent as _defineComponent } from 'vue'
import { resolveDynamicComponent as _resolveDynamicComponent, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "book-cover" }

import { computed } from 'vue'

import type { DocCoverProps } from '@/models/interfaces'
import { cacheBust as addCacheBust } from '@/models/doc'

import BookFallbackCover from './BookFallbackCover.vue'
import { IS_PRERENDERING } from '@/init/settings'
import LazyImage from '@/app/components/podcast/card/LazyImage.vue'
import PublicImage from '@/app/components/podcast/card/PublicImage.vue'
import { isContentTranslated } from '@/services/weglot'


export default /*@__PURE__*/_defineComponent({
  __name: 'BookCover',
  props: {
    doc: {},
    coverClass: {},
    fallbackCoverClass: {},
    cacheBust: { type: Boolean },
    sizes: {},
    srcset: {}
  },
  setup(__props: any) {

const props = __props

const useFallbackCover = computed(() => {
  return isContentTranslated()
})

const coverUrl = computed(() => {
  if (!props.doc.cover_image) {
    return
  }

  if (props.cacheBust) {
    return addCacheBust(props.doc.cover_image)
  }

  return props.doc.cover_image
})

const lazyComponent = computed(() => {
  return !IS_PRERENDERING ? LazyImage : PublicImage
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (__props.doc.cover_image && !useFallbackCover.value)
      ? (_openBlock(), _createBlock(_resolveDynamicComponent(lazyComponent.value), {
          key: 0,
          src: coverUrl.value,
          crossorigin: "anonymous",
          class: _normalizeClass(["book-cover__image", __props.coverClass]),
          sizes: __props.sizes,
          srcset: __props.srcset,
          alt: ""
        }, null, 8, ["src", "class", "sizes", "srcset"]))
      : _createCommentVNode("", true),
    (_unref(IS_PRERENDERING) || !__props.doc.cover_image || useFallbackCover.value)
      ? (_openBlock(), _createBlock(BookFallbackCover, {
          key: 1,
          title: __props.doc.title,
          subtitle: __props.doc.author,
          class: _normalizeClass(__props.fallbackCoverClass)
        }, null, 8, ["title", "subtitle", "class"]))
      : _createCommentVNode("", true)
  ]))
}
}

})